import React, { FunctionComponent, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import "./success.scss"
import AxisButton from '../../components/button/button';
import Text from '../../components/typography/typgraphy';
import pending from '../../assets/images/mpin-err.svg'
import { LOGOUT, SUCCESSFULLY_SUBMITTED } from '../../constants/messages';
import { ProfileDetailsState } from '../../core/reducers/profileDetailsReducer';
import { getTransactionIdFromURL, logoutUser } from '../../constants/utils';
import successGif from "../../assets/images/success.gif"
import { RightTickFilled } from '../../assets/svgs/svg';
import { pushDataLayer, SUCCESS_LOGOUT_GA, COPY_URN_GA, SUCCESS_PAGELOAD_PARAM, SUCCESS_PAGELOAD_VPV } from '../../constants/gaConstants';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { TransactionState } from '../../core/reducers/transactionDetailsReducer';
import { AuthState } from '../../core/reducers/authReducer';

interface ISuccessPageProps {
  profileDetails: ProfileDetailsState;
  isAuthenticated: boolean;
  isLoading: boolean;
  email: string;
  referenceNo: string;
  partnerName: string;
  getProfileDetails: ()=>void;
  transactionDetails: TransactionState;
  partnerData: AuthState;
}

const Success: FunctionComponent<ISuccessPageProps> = (props) => {
  const history = useHistory();
  const location = useLocation();
  const errorCode = location.state?.errorCode;

  const { email, transactionDetails, partnerData } = props;
  const {referenceNo, partnerName, profileDetails, getProfileDetails } = props;
  const [highlighedClass, setHighlighedClass] = useState(false)
  const txnId = getTransactionIdFromURL()

  // GA on page load
  useEffect(() => {
    pushDataLayer(SUCCESS_PAGELOAD_VPV(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
    pushDataLayer(SUCCESS_PAGELOAD_PARAM(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))

    if(!profileDetails.emailId){
      getProfileDetails()
     }
  }, [])

  const handleLogout = () => {
    pushDataLayer(SUCCESS_LOGOUT_GA(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
    logoutUser()
  }

  const handleCopy = () => {
    pushDataLayer(COPY_URN_GA(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))

    navigator.clipboard.writeText(referenceNo.toUpperCase()) 
    setHighlighedClass(true)
  }

  return (
    <div className="success-container">
      <div className="success-wrapper">
        { errorCode == 8510 ?
          <div className="successful-header">
            <img src = {pending} height={20} width={20} className="successful"/>
            <Text fontWeight={700} className="heading">Submission Pending</Text>
          </div>
          :<div className="successful-header">
            <RightTickFilled height={20} width={20} className="successful" />
            <Text fontWeight={700} className="heading">{SUCCESSFULLY_SUBMITTED}</Text>
          </div>
        }
        <div className="successful-body">
        { errorCode == 8510 ? <Text className="sub-heading">This is taking longer than expected!</Text> :<Text className="sub-heading">We have successfully received your request</Text>}
        <img className="success-gif" src={successGif} alt="success..." />
        <Text fontWeight={700} className="heading-1">We are analysing your documents</Text>
        {/* <Text className="sub-heading">Status of Your Remittance request will be sent to you on <b>{email}</b> in next 48 hours</Text>
        <Text className="sub-heading logout-info">By pressing Logout, we will be logging you out from the session.</Text> */}
        <Text className="sub-heading">Status of Your Remittance request will be sent to you on <b>{profileDetails.emailId}</b> in next 48 hours</Text>
        <Text fontWeight={700} className="heading-1">Your URN generated from {partnerName}</Text>
        <div className="urn-container">
          <p ><span className={highlighedClass ? "highlighed" : ""}><span className="text-uppercase">{referenceNo}</span></span> <span>
            <ContentCopyIcon onClick= {handleCopy}/>
            </span></p>
        </div>
        <Text className="sub-heading">Please copy this Unique Reference Number for any queries related to this transaction</Text>
        <Text className="sub-heading logout-info">By pressing Logout, we will be logging you out from the session.</Text>
        <div className="submit-btn-container">
          <AxisButton onClick={handleLogout} disableElevation customStyle={"submit-btn-primary"} variant="contained">
            <Text className={"submit-btn-text"}>{LOGOUT}</Text>
          </AxisButton>
        </div>
        </div>
      </div>
    </div>
  )
}


export default Success;